import { CustomIconProps } from "./CustomIconProps";

export function ProfileIcon(props: CustomIconProps<SVGElement>) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.3332 24.5V22.1667C23.3332 20.929 22.8415 19.742 21.9663 18.8668C21.0912 17.9917 19.9042 17.5 18.6665 17.5H9.33317C8.09549 17.5 6.90851 17.9917 6.03334 18.8668C5.15817 19.742 4.6665 20.929 4.6665 22.1667V24.5"
        stroke={props.color || "black"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round" />
      <path
        d="M14.0002 12.8333C16.5775 12.8333 18.6668 10.744 18.6668 8.16667C18.6668 5.58934 16.5775 3.5 14.0002 3.5C11.4228 3.5 9.3335 5.58934 9.3335 8.16667C9.3335 10.744 11.4228 12.8333 14.0002 12.8333Z"
        stroke={props.color || "black"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round" />
    </svg>
  );
}
